import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal, Form } from "react-bootstrap";

import { approveWithdrawal, rejectWithdrawal } from "../../actions/withdrawal";

import Skeleton from "./../../components/skeleton";

export default function WithdrawalList({ withdrawals, user }) {

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [showDetailForm, setShowDetailFrom] = useState(false);
  const [showApproveFrom, setShowApproveForm] = useState(false);
  const [showRejectFrom, setShowRejectForm] = useState(false);

  const [selectedRequest, setSelectedRequest] = useState(null);
  const [description, setDescription] = useState("");

  const [filter, setFilter] = useState("All");

  const [paginatedDataItem, setPaginatedDataItem] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [resultsPerPage, setResultsPerPage] = useState(10);

  const handlePageChange = (newPage) => {
    window.scrollTo(0, 0);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    setPaginatedDataItem(withdrawals);
  }, [withdrawals]);

  const handleApprove = async (id) => {
    setLoading(true);
    await dispatch(approveWithdrawal(id));
    setLoading(false);
    resetApproveForm();
  }
  const handleReject = async (id) => {
    setLoading(true);
    await dispatch(rejectWithdrawal(id, description));
    setLoading(false);
    resetRejectForm();
  }

  const resetDetailForm = () => {
    setShowDetailFrom(false);
    setSelectedRequest(null);
  }
  const resetApproveForm = () => {
    setShowApproveForm(false);
    setSelectedRequest(null);
  }
  const resetRejectForm = () => {
    setShowRejectForm(false);
    setSelectedRequest(null);
  }

  const applyFilter = (arr) => {
    if (filter === "All") return arr;
    return arr.filter(item => item.status === filter);
  }

  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentResults = paginatedDataItem ? [...paginatedDataItem].slice(startIndex, endIndex) : null;
  const totalPages = Math.ceil(applyFilter(paginatedDataItem)?.length / resultsPerPage);

  return (
    <div className="box-table bg-white border border-top-0 p-2">

      {/* Detail modal */}
      <Modal
        show={showDetailForm}
        onHide={resetDetailForm}
        keyboard={false}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Withdrawal Request {selectedRequest?._id}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="d-flex flex-wrap"
            style={{ gap: 24 }}
          >
            <div
              className="d-flex flex-wrap"
              style={{ gap: 32 }}
            >
              <div className="d-flex flex-column">
                <p>Amount</p>
                <h4>${selectedRequest?.amount}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>Status</p>
                <h4>{selectedRequest?.status}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>Requested at</p>
                <h4>
                  {new Date(selectedRequest?.createdAt || Date.now())?.toISOString()?.replace("T", " ")?.slice(0, 16)}
                </h4>
              </div>
              <div className="d-flex flex-column">
                <p>{selectedRequest?.status === 'Rejected' ? 'Rejected' : 'Approved'} at</p>
                <h4>
                  {selectedRequest?.status !== 'Pending' ? new Date(selectedRequest?.updatedAt || Date.now())?.toISOString()?.replace("T", " ")?.slice(0, 16) : '-'}
                </h4>
              </div>
            </div>

            <div
              className="d-flex flex-wrap"
              style={{ gap: 32 }}
            >
              <div className="d-flex flex-column">
                <p>Freelancer Username</p>
                <h4>{selectedRequest?.user_id?.user_name}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>Freelancer Email</p>
                <h4>{selectedRequest?.user_id?.email}</h4>
              </div>
            </div>

            <div
              className="d-flex flex-wrap"
              style={{ gap: 32 }}
            >
              <div className="d-flex flex-column">
                <p>Bank type</p>
                <h4>{selectedRequest?.bank?.type === 'local' ? 'Local Saudi Bank' : 'International Bank'}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>IBAN No</p>
                <h4>{selectedRequest?.bank?.iban}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>Beneficiary Name</p>
                <h4>{selectedRequest?.bank?.beneficiary_name}</h4>
              </div>
              <div className="d-flex flex-column">
                <p>Bank Name</p>
                <h4>{selectedRequest?.bank?.bank_name}</h4>
              </div>
            </div>

            {selectedRequest?.bank?.type !== 'local' && (
              <div
                className="d-flex flex-wrap"
                style={{ gap: 32 }}
              >
                <div className="d-flex flex-column">
                  <p>Swift Code</p>
                  <h4>{selectedRequest?.bank?.swift_code}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Bank Country</p>
                  <h4>{selectedRequest?.bank?.bank_country}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Bank City</p>
                  <h4>{selectedRequest?.bank?.bank_city}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Place of Issuance</p>
                  <h4>{selectedRequest?.bank?.place_of_issuance}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary ID No</p>
                  <h4>{selectedRequest?.bank?.beneficiary_id_no}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary Date of Birth</p>
                  <h4>{selectedRequest?.bank?.beneficiary_date_of_birth}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary Phone</p>
                  <h4>{selectedRequest?.bank?.beneficiary_phone}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary Address</p>
                  <h4>{selectedRequest?.bank?.beneficiary_address}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary Country</p>
                  <h4>{selectedRequest?.bank?.beneficiary_country}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary City</p>
                  <h4>{selectedRequest?.bank?.beneficiary_city}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary State</p>
                  <h4>{selectedRequest?.bank?.beneficiary_state}</h4>
                </div>
                <div className="d-flex flex-column">
                  <p>Beneficiary Zip Code</p>
                  <h4>{selectedRequest?.bank?.beneficiary_zip_code}</h4>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={resetDetailForm}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Approve modal */}
      <Modal
        show={showApproveFrom}
        onHide={resetApproveForm}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Approve Withdrawal Request?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to approve this withdrawal request? this action cannot be undone.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={resetApproveForm} disabled={loading}>
            No
          </Button>
          <Button
            variant="secondary"
            onClick={() => handleApprove(selectedRequest._id)}
            disabled={loading}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Reject modal */}
      <Modal
        show={showRejectFrom}
        onHide={resetRejectForm}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject Withdrawal Request?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to reject this withdrawal request? this action cannot be undone.
          <Form.Group className="my-3">
            <Form.Label>Reject reason</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              type="text"
              placeholder="Reject reason (optional)"
              name="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="my-2 w-100"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={resetRejectForm} disabled={loading}>
            No
          </Button>
          <Button
            variant="secondary"
            onClick={() => handleReject(selectedRequest._id)}
            disabled={loading}
          >
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="d-flex justify-content-end align-items-center">
        <Form.Group className="my-2">
          <Form.Label>Filter status</Form.Label>
          
          <select
            className="form-control" 
            id="select"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{marginRight:"32px", marginBottom:"12px"}}
          >
            <option value="All" >All</option>
            {["Pending", "Approved", "Rejected"].map((status) => (
              <option
                key={status}
                value={status}
              >
                {status}
              </option>
            ))}
          </select>
         
        </Form.Group>
      </div>
      <div className="overflow-scroll ">

      <table className="table table-layout-fixed m-0 w-100" style={{ overflowX: 'auto' }}>
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {withdrawals === null &&
            [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => (
              <tr key={i}>
                <td>
                  <Skeleton height={25} />
                </td>
                <td>
                  <Skeleton height={25} />
                </td>
                <td>
                  <Skeleton height={25} />
                </td>
                <td>
                  <Skeleton height={25} />
                </td>
              </tr>
            )
          )}

          {withdrawals !== null &&
            (currentResults && currentResults.length > 0 ? (
              applyFilter([...currentResults]).map((wd) => (
                <tr key={wd._id}>
                  <td>
                    {new Date(wd.createdAt)?.toISOString()?.replace("T", " ")?.slice(0, 16)}
                  </td>
                  <td>
                    {wd.amount}
                  </td>
                  <td>
                    {wd.status}
                  </td>
                  <td className="d-flex flex-wrap" style={{ gap: 8 }}>
                    {(user.type === 'Admin' && wd.status === 'Pending') && (
                      <>
                        <Button
                          variant="primary"
                          disabled={loading}
                          onClick={() => {
                            setSelectedRequest(wd);
                            setShowApproveForm(true);
                          }}
                        >
                          Approve
                        </Button>
                        <Button
                          variant="danger"
                          disabled={loading}
                          onClick={() => {
                            setSelectedRequest(wd);
                            setShowRejectForm(true);
                          }}
                        >
                          Reject
                        </Button>
                      </>
                    )}
                    <Button
                      variant="primary"
                      disabled={loading}
                      onClick={() => {
                        setSelectedRequest(wd);
                        setShowDetailFrom(true);
                      }}
                    >
                      Details
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={7} className="text-center">
                  No record found
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {totalPages > 1 && (
          <nav>
            <ul className="pagination justify-content-center">
              {[...Array(totalPages)].map((_, index) => {
                const pageNumber = index + 1;
                return (
                  <li
                    key={pageNumber}
                    className={`page-item ${
                      pageNumber === currentPage ? "active" : ""
                    }`}
                  >
                    <button
                      className="page-link"
                      onClick={() => handlePageChange(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  </li>
                );
              })}
            </ul>
          </nav>
        )}
      </div>
    </div>
  );
}
